import axios from 'axios';
import { useAuthStore } from '@/stores/auth.store';

const VITE_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

/**
 * Axios client instance for interacting with the backend API.
 * Configured with token injection and automatic 401 session expiry handling.
 */
export const apiClient = axios.create({
  baseURL: VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to automatically inject the Bearer token
apiClient.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle session expiry (401 Unauthorized)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth store
      useAuthStore.getState().clearAuth();

      // Redirect to login page, preserving redirect URL
      const currentPath = window.location.pathname + window.location.search;
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signup')) {
        window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  }
);
export default apiClient;
